import React, { Component } from 'react';
import '../App.css';

class SuccessPageLater extends Component {

  componentDidMount() {
    setTimeout(function(){window.location.href = 'https://tradeshow.solepaycard.com'}, 12000);
  }

  render() {
    
    return (
      <section id="success-page">
        <h2>Thank you! Keep an eye on your inbox for an email from a SOLE representative next week.</h2>
      </section>
    );
  }
}

export default SuccessPageLater;
